/* ========================================================================
 *  module feedback
 * ========================================================================
*/
FD.FEEDBACK = (function ($, me) {
    'use strict';

    var child = me.FEEDBACK || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_EVALS = '/Evals/Feedback/';

    var MESSAGE_CONTAINER_ELEM = '[data-modalmessage="true"]';
    var PARENT_ELEM = '[data-parent="true"]';
    var MODAL_ELEM = '#FEEDBACK_MODAL';

    var feedback;
    var modal;
    var messageModalContainer;
    var feedbackType = {
        PeerFeedback: 1,
        SummarySentence: 2,
        HitsAndMisses: 3,
        Overview: 4,
        PerformanceLevel: 5
    }

    
    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        SAVE_BTN: 10
    };


    /************************************************************
     * Objects
     ************************************************************/

    function setFeedbackItem() {
        return {
            ID: null,
            ForID: null,
            IsComplete: null,
            AuthorID: null,
            Text: null,
            CoachText: null,
            GrowthType: null,
            ShowOnEval: null,
            FeedbackType: 1, // Peer Feedback
            PeriodID: null,
            PerformanceLevel: null,
            PerformanceLevelCoach: null
        }
    }


    //  load container
    function loadContainer() {
        if (me.getModalLock()) {
            return;
        }

        me.setModalLock(true);
        var options = {
            params: {},
            url: URL_EVALS + 'GetSiteFeedbackModal',
            callback: afterData,
            ishtml: true,
            cancelprevious: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            
            $('body').append(result);

            modal = $(MODAL_ELEM);

            modal.off().on('shown.bs.modal', function () {
                me.setToolTipDestroy();
                me.CONTROL.setValidateContainer(modal); // MUST BE FIRST
                me.CONTROL.setButton(true, modal);
                me.CONTROL.setAutoComplete(modal);
                me.CONTROL.setMessageContainer(MESSAGE_CONTAINER_ELEM);
                me.CONTROL.setTextArea(true, modal);
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                $(MODAL_ELEM).remove();
            }).modal('show');

            messageModalContainer = $(MESSAGE_CONTAINER_ELEM);
            messageModalContainer = me.CONTROL.setMessageContainer(MESSAGE_CONTAINER_ELEM);
        }      
    }


    /* ========================================================================
     *  feedback methods
     * ========================================================================
    */


    // save new piece of feedback
    function setSaveButton(data) {
        if (me.CONTROL.Validate(MODAL_ELEM)) {
            var item = setFeedbackItem(null, feedbackType.PeerFeedback);
            var frmElem = me.getFormFields(MODAL_ELEM);
            item.Text = frmElem.Text;
            item.PeriodID = frmElem.PeriodID;
            item.ForID = frmElem.ForID;
            item.GrowthType = frmElem.GrowthType;

            handleFeedbackCRUD(item);

            $(MODAL_ELEM).find('textarea').val('').text('');
        }
    }


    // submit update to server
    function handleFeedbackCRUD(item) {
        messageModalContainer.setSpinner();

        var options = {
            url: URL_EVALS + "HandleFeedbackUpdateCRUD",
            params: {
                item: item
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            messageModalContainer.setMessage(result, null);
        }
    }




    /* ========================================================================
     *  page init
     * ========================================================================
    */


    //  init
    child.init = function () {
        loadContainer();
    };



    //   after control event
    child.getAfterControlEvent = function (data) {
        var result = data;

        // save button
        if (result.tag === tag.SAVE_BTN) setSaveButton();
    };

    return child;
}(jQuery, FD));



